/**
 * @file   src\actions\common.js
 * @brief  This file is responsible for redux actions related to master data
 * @date   April, 2023
 * @author ZCO Engineer
 * @copyright (c) 2023, ZCO
 */
import { convertToNumber } from "../helpers/validations";

export const handleTextBoxChange = (e) => {
  return e.target.value;
};

export const handleRadioButonChange = (e) => {
  return e.target.value;
};

export const handleItemClick = (clickedItemId, currentArray) => {
  const clickedId = convertToNumber(clickedItemId);
  let currentSelectedItemArray = [];
  let isItemIncluded = false
  if (_.includes(currentArray, clickedId)) {
    currentSelectedItemArray = currentArray.filter((e) => e !== clickedId);
    isItemIncluded = true
  } else {
    currentSelectedItemArray = [...currentArray, clickedId];
  }
  return {currentSelectedItemArray, isItemIncluded };
};






export const capitalizeString = (str) => {
  return str.charAt(0).toUpperCase() + str.slice(1);
};